import React, {useEffect, useState} from 'react';
import './index.css';
import {I18nextProvider, Trans, useTranslation} from 'react-i18next';
import _get from 'lodash/get';
import InfoDialog from '../../../../../components/dialogs/InfoDialog';
import Select from 'react-select';
import globals from '../../../../../utils/config/globals';
import {Modal} from 'react-bootstrap';
import FaceAssessmentModule from './components/FaceAssessmentModule';
import _isEqual from 'lodash/isEqual';
import {deviceOptions} from '../../config/utils/optionsUtils';
import storeUtils from '../../../../../utils/storeUtils';
import Toggle from 'react-toggle';

export default function SkincareFaceAssessmentPreview({
  commonData = {},
  config,
  customerId,
}) {
  const {i18n} = useTranslation();
  const [enable, setEnable] = useState(true);
  const [screenMode, setScreenMode] = useState(
    deviceOptions.find(
      option => option.value === storeUtils.getUiConfigSettingDevice(customerId)
    ) || deviceOptions[0]
  );
  const [show, setShow] = useState(true);
  const [fullScreen, setFullScreen] = useState(false);
  const [language, setLanguage] = useState(
    globals.languages2.find(l => l.i18n === i18n.language)
  );
  const [isLandscape, setIsLandscape] = useState(false);
  const [categories, setCategories] = useState([]);
  const localI18n = i18n.cloneInstance({
    lng: language && language.i18n ? language.i18n : 'en',
  });

  useEffect(() => {
    setIsLandscape(_isEqual(screenMode.value, 'padLandscape'));
  }, [screenMode]);

  useEffect(() => {
    setCategories(_get(config, 'category', []).filter(t => !t.disabled));
    setEnable(_get(config, 'enable'));
  }, [config]);

  return (
    <>
      <div
        className={
          isLandscape
            ? 'face_assessment_preview-container-landscape'
            : 'face_assessment_preview-container'
        }
      >
        <div className="face_assessment_preview-tools">
          <div className="d-flex align-items-center">
            <strong className="flex-grow-1">
              {_get(screenMode, 'label')}
              {isLandscape && (
                <InfoDialog
                  trigger={'click'}
                  placement="right"
                  description={
                    <Trans i18nKey="p.s.uiconfiguration.preview.landscape.desc">
                      Landscape Mode is supported only on iPads with the front
                      camera positioned on the long side. Please verify your
                      device's compatibility before applying the Landscape Mode
                      UI settings.
                    </Trans>
                  }
                >
                  <label className="cursor-help">
                    &nbsp;
                    <i className="fa fa-question-circle" />
                  </label>
                </InfoDialog>
              )}
            </strong>
            <InfoDialog
              trigger={'click'}
              placement="auto"
              popoverMaxWidth={'400px'}
              title={
                <>
                  <Trans i18nKey="p.s.u.c.preview.setting">
                    Preview Setting
                  </Trans>
                  <div className="float-right">
                    <i
                      className="fa fa-times cursor-pointer"
                      style={{fontSize: '20px'}}
                      onClick={() => document.body.click()}
                    />
                  </div>
                </>
              }
              description={
                <div className="d-flex flex-column kt-margin-t-10 kt-margin-b-10">
                  <div>
                    <div className="float-left kt-margin-r-20">
                      <Trans i18nKey="tutorials.steps.addskulooktour.preview.screen">
                        Preview Screen
                      </Trans>
                    </div>
                    <div className="float-right">
                      <Toggle
                        checked={show}
                        onChange={e => setShow(e.target.checked)}
                        icons={{unchecked: false}}
                      />
                    </div>
                  </div>
                  <div className="kt-margin-t-10">
                    <div className="float-left kt-margin-r-20 kt-margin-t-10">
                      <Trans i18nKey="p.g.a.updateaccount.device">Device</Trans>
                    </div>
                    <div className="float-right">
                      <div
                        style={{
                          width: '180px',
                        }}
                      >
                        <Select
                          options={deviceOptions.filter(
                            o => o.value !== 'mobile'
                          )}
                          onChange={o => {
                            storeUtils.setUiConfigSettingDevice(
                              customerId,
                              _get(o, 'value')
                            );
                            setScreenMode(o);
                          }}
                          value={screenMode}
                          isSearchable={false}
                          isClearable={false}
                          placeholder={
                            <Trans i18nKey="c.c.select.placeholder">
                              Select...
                            </Trans>
                          }
                        />
                      </div>
                    </div>
                  </div>
                  <div className="kt-margin-t-10">
                    <div className="float-left kt-margin-r-20 kt-margin-t-10">
                      <Trans i18nKey="p.c.listrequests.language">
                        Language
                      </Trans>
                    </div>
                    <div className="float-right" style={{width: '120px'}}>
                      <Select
                        options={globals.languages2}
                        onChange={o => {
                          localI18n.changeLanguage(o.i18n);
                          setLanguage(o);
                        }}
                        value={language}
                        isSearchable={false}
                        isClearable={false}
                        placeholder={
                          <Trans i18nKey="c.c.select.placeholder">
                            Select...
                          </Trans>
                        }
                      />
                    </div>
                  </div>
                </div>
              }
            >
              <i
                className="fa fa-cog cursor-pointer"
                style={{fontSize: '26px'}}
              />
            </InfoDialog>
            {show && (
              <img
                src={require('../../../../../assets/icons/up-right-and-down-left-from-center-solid.svg')}
                className="cursor-pointer kt-margin-l-10"
                style={{width: '24px'}}
                alt=""
                onClick={() => setFullScreen(true)}
              />
            )}
          </div>
        </div>
        {show && (
          <I18nextProvider i18n={localI18n}>
            <FaceAssessmentModule
              commonData={commonData}
              categories={categories}
              screenMode={screenMode}
              enable={enable}
              isLandscape={isLandscape}
            />
            <Modal
              size="sm"
              show={fullScreen}
              onHide={() => {
                setFullScreen(false);
              }}
              centered={true}
              dialogClassName="fullscreen-modal"
            >
              <Modal.Body className="fullscreen-modal-overlay">
                <div className="fullscreen-center-wrapper">
                  <div className="face_assessment_preview-module-expand">
                    <FaceAssessmentModule
                      commonData={commonData}
                      categories={categories}
                      isLandscape={isLandscape}
                      enable={enable}
                      isExpand={true}
                    />
                  </div>
                </div>
              </Modal.Body>
            </Modal>
          </I18nextProvider>
        )}
      </div>
    </>
  );
}
